import React from "react";
import {WidgetProps} from "../widget";
import {DebounceSelect} from "../../../../debounce-select/debounce.select";
import {useTranslate} from "../../../../../../hooks/translate.hook";
import {agentService} from "../../../../../../services/agents/agent.service";

const clientOptionsFetcher = async (value: string, valueAsCode: boolean) => {
    const accounts = await agentService.searchWholesaleAccount(value);
    return accounts.map(account => ({
        value: valueAsCode ? account.agent.number : account.id,
        label: account.agent.number + " - " + account.agent.name
    }));
};

interface UIInputWidgetClientProps extends WidgetProps {
    valueAsCode?: boolean;
}

export const UIInputWidgetClient: React.FC<UIInputWidgetClientProps> = ({value, onChange, valueAsCode, multiple, maxCount}) => {

    const t = useTranslate();

    return (
        <DebounceSelect
            placeholder={t("CLIENT.SEARCH")}
            fetchOptions={(v) => clientOptionsFetcher(v, valueAsCode || false)}
            labelInValue={false}
            allowClear={true}
            value={value}
            onChange={onChange}
            style={{width: "380px"}}
            mode={multiple ? "multiple" : undefined}
            maxCount={maxCount}
            maxTagCount={multiple ? 1 : undefined}
        />
    )
}